import React, { useState } from 'react';


const BinaryCodeTranslator = () => {
  const [binary, setBinary] = useState('');
  const [number, setNumber] = useState('');
  const [error, setError] = useState('');

  // Handle binary input and translate to number
  const handleBinaryChange = (e) => {
    setBinary(e.target.value);
    try {
      const binaryText = e.target.value.replace(/\s+/g, ''); // Remove any extra spaces
      const translatedNumber = binaryToNumber(binaryText);
      setNumber(translatedNumber);
      // const binaryText = e.target.value;
      // setBinary(binaryText);
      calculateTextStats(binaryText);
      setError('');
    } catch (error) {
      setError('Invalid binary code');
      setNumber('');
    }
  };


    // Clear input fields
  const clearFields = () => {
    setBinary('');
    setNumber('');
    setError('');
  };

  // Handle number input and translate to binary
  const handleNumberChange = (e) => {
    setNumber(e.target.value);
    try {
      const translatedBinary = numberToBinary(e.target.value);
      setBinary(translatedBinary);
      setError('');
    } catch (error) {
      setError('Invalid number');
      setBinary('');
    }
  };

  // Convert binary to number
  const binaryToNumber = (binary) => {
    return parseInt(binary, 2);
  };

  // Convert number to binary
  const numberToBinary = (number) => {
    return parseInt(number).toString(2);
  };

  // // Copy content to clipboard
  // const handleCopy = (text) => {
  //   navigator.clipboard.writeText(text);
  // };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Number'); // State for button label

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text); // Copy text to clipboard
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Number'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };
  
    // Function to calculate text statistics
    const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };


      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(binary);
  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      <div className="row g-4">
        <div className="col-md-6">
          <label className="form-label h5">Binary code   </label>
          <textarea
            className="form-control"
            value={binary}
            id = "binary-code-input"
            onChange={handleBinaryChange}
            rows="10"
          ></textarea>
          <button
            className="btn btn-primary mt-3"
            onClick={() => handleCopy(binary)}
          >
          Copy binary code
          </button>
          <button className="btn btn-danger mt-3" onClick={clearFields}>
            Clear
          </button>
        </div>
        <div className="col-md-6">
          <label className="form-label h5">Number</label>
          <textarea
            className="form-control"
            value={number}
            onChange={handleNumberChange}
            rows="10"
          ></textarea>
       <button
            className="btn btn-primary mt-3"
            onClick={() => handleCopy(number)}
          >
            {copyButtonLabel}
          </button>
        </div>
        <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
      </div>
      {error && (
        <div className="alert alert-danger mt-4" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default BinaryCodeTranslator;
